import { render, staticRenderFns } from "./SHeaderSection.vue?vue&type=template&id=ddb8d85e"
import script from "./sHeaderSection.ts?vue&type=script&lang=ts&external"
export * from "./sHeaderSection.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports